<template>
    <div :class="textboxAreaGroupClass()">
        <textarea :class="textboxAreaControlClass()" 
                :id="textboxArea.id" 
                :name="textboxArea.name" 
                :placeholder="textboxArea.placeholder"
                :aria-describedby="textboxArea.id+'-help'" 
                :data-vv-as="textboxArea.errorMsgName"
                v-validate="textboxArea.veeRules" 
                v-model="textboxArea.value"
        ></textarea>
        <div class="textboxArea-errors" v-show="errors.has(textboxArea.name)">{{ errors.first(textboxArea.name) }}</div>
        <small v-if="textboxArea.helpText" :id="textboxArea.id+'-help'" class="input-help-text">{{ textboxArea.helpText }}</small>
    </div>
</template>

<script>

export default {
  name: 'textbox-area',
  props: {
    textboxArea: {
        type: Object,
        default: function () {
          return {
            id: 'textDefault',
            class: 'text-input-default',
            name: 'textDefault',
            placeholder: 'Enter text...',
            helpText: 'Help text...',
            veeRules: 'required|alpha',
            value: ''
          }
        }
      }
  },
  methods: {
      textboxAreaGroupClass: function() {
        var result = [];
        
        if(this.errors.has(this.textboxArea.name))
            result.push('has-warning')
        if(!this.errors.has(this.textboxArea.name) && this.isFormDirty)
            result.push('has-success')
        return result;
    },
    textboxAreaControlClass: function() {
        var result = [];
        result.push(this.textboxArea.class);
        if(this.errors.has(this.textboxArea.name))
            result.push('input-warning')
        if(!this.errors.has(this.textboxArea.name))
            result.push('input-success')
        return result;
    }
  },
  computed: {
    isFormDirty() {
      return Object.keys(this.fields).some(key => this.fields[key].dirty);
    }
  }
}
</script>

<style>
.m4c-textarea {
    font-family: 'Brandon Grotesque', sans-serif!important;
}


.m4c-textarea {
    border-radius: 20px;
    padding: 10px 15px;

    width: 100%;
    height: 100px;
    max-height: 200px;
    font-size: 21px;
    line-height:21px;

    border: 5px solid #EDEDED;
    background-color: #F9F9F9;
     -webkit-box-shadow: inset 0px 2px 5px 0px rgba(0,0,0, 0.2);
    -moz-box-shadow:    inset 0px 2px 5px 0px rgba(0,0,0, 0.2);
    box-shadow:         inset 0px 2px 5px 0px rgba(0,0,0, 0.2);
}

.textboxArea-errors{
    font-size: 14px;
    line-height: 18px;
    font-weight: 400;
    margin-top: 6px;
    color: red;
}


.input-warning{
    border-color: #FF0000;
}
/*
textarea{
    font-size: 1rem;
    background: #ECECEC;
    color: #333;
    border-color: #ECECEC; 
    font-weight: bold;
    width: 100%;
    border-style: none;
    transition: .2s ease-in-out;
    transition-property: color,background-color,border;
    touch-action: manipulation;
    padding: 10px;
}

textarea::placeholder{
    color: #999;
}

textarea:focus {
    outline: none;
    color: #333;
    border-color: #DDDDDD;
}



.input-warning{
    border-color: #FF0000;
}
*/
/*
.input-success{
    border-color: #53CF99;
}*/


</style>

